import { BillingAddress } from './../../../../../new-service/interfaces/VehicleStorage';
import { FORM_KEYS } from './../../edit-service.service';
import { format } from 'date-fns';
import { FunnelService } from './../../../../../new-service/services/funnel.service';
import { scrollToElement } from 'src/app/shared/utilities/utils';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { EditServiceService } from '../../edit-service.service';
import * as moment from 'moment';
import { ProductAvailabilityParams } from 'src/app/pages/new-service/services/interfaces/funnel.interface';
import { Subscription } from 'rxjs';
import { BillingContact, SummaryData, User } from 'src/app/pages/new-service/interfaces/SummaryData';
import { ConcatenatedHour, Hour } from 'src/app/pages/new-service/interfaces/Hour';
import { SharedFunnelService } from 'src/app/shared/functions/shared-functions';
import { ES_Zones } from 'src/app/core/constants/ZonesIds';
import { ActiveRoutesDetail } from 'src/app/pages/active-routes/components/active-routes-detail/interfaces/ActiveRoutesDetail.interface';

export enum PickUpHourType {
  RANGE = "RANGE",
  SPECIFIC = "SPECIFIC"
}

export interface DateObject {
  Date: string;
  Hour: string;
}

export interface SpecificHour {
  Start: string | undefined;
  End: string | undefined;
}


export interface DateAvailableFee {
  Key: string;
  Amount: number;
}

@Component({
  selector: 'app-day-contact-info-step',
  templateUrl: './day-contact-info-step.component.html',
  styleUrls: ['./day-contact-info-step.component.scss']
})
export class DayContactInfoStepComponent {

  pickupContactSamePerson: boolean = false;

  PickUpHourType = PickUpHourType;
  PickUpHourTypeList = Object.values(PickUpHourType);
  PickUpHourTypeSelected: PickUpHourType | undefined = undefined;

  containerId: string = "container-id"
  DestinationContainerId: string = "destinator-container-id"
  StartDateObject: DateObject | undefined;
  EndDateObject: DateObject | undefined;

  SpecificHourSelected: SpecificHour = {
    Start: "",
    End: ""
  }

  NotHoursAvailable: boolean = false;
  NotRangeAvailable: boolean = false;

  FORM_KEYS = FORM_KEYS;

  BillingContacts?: BillingContact[];
  FilteredContacts?: BillingContact[];
  BillingCentersAvailable = false;

  hoursOfDay: string[] = [];
  hoursOfDayEndDate: string[] = [];
  hoursOfDaySpecific: string[] = [];

  LoadingAvailableHours: boolean = false;

  ES_Zones = ES_Zones;

  @Input() DayContactForm: FormGroup = this.EditServiceService.createDayContactDataGroup();
  @Input() PrincipalProductId: string = '';
  @Input() ServiceForm: FormGroup | undefined | null;
  @Input() ServiceDetails: ActiveRoutesDetail = {} as ActiveRoutesDetail;

  @Output() updateServiceDetailsEmitter = new EventEmitter()

  FakeSummaryData: SummaryData = {} as SummaryData;

  constructor(private EditServiceService: EditServiceService, private FunnelService: FunnelService, private sharedFunnelService: SharedFunnelService,
  ) { }

  ngOnInit() {

    this.pickupContactSamePerson = this.areContactsEqual();
    this.FakeSummaryData.CustomFields = this.ServiceDetails.CustomFields;

    this.initializeDateObjects();
    this.initContactFormSync();
    this.loadBillingContacts();
    this.checkPickupType();
    this.getAvailableHours();
  }

  // BILLING 

  showDropdownBillingContacts: boolean = false;

  loadBillingContacts() {
    this.FunnelService.getUserContact().subscribe((user: User) => {
      this.BillingContacts = user.BillingContacts;
      this.FilteredContacts = this.BillingContacts;
      this.BillingCentersAvailable = this.BillingContacts !== undefined && this.BillingContacts.length > 0;
    });
  }

  filterContacts() { }
  onFocusInput() { this.showDropdownBillingContacts = true }
  onBlurDropdown() { this.showDropdownBillingContacts = false }
  selectContact(event: any) { }
  getDisplayName() { }

  billingContactEmitter(event: BillingContact): void {
    let BillingAddress = {
      Identifier: event.Identifier,
      DisplayName: event.DisplayName,
      FiscalCode: event.FiscalCode
    }
    this.DayContactForm.get([FORM_KEYS.BillingAddress])?.setValue((BillingAddress))
  }

  // DATE - HOURS

  initializeDateObjects(): void {
    const startDateValue = this.DayContactForm.get('StartDate')?.value;
    const endDateValue = this.DayContactForm.get('EndDate')?.value;

    this.StartDateObject = {
      Date: this.getDateString(startDateValue),
      Hour: this.getHourString(startDateValue)
    };

    this.EndDateObject = {
      Date: this.getDateString(endDateValue),
      Hour: this.getHourString(endDateValue)
    };
  }

  checkPickupType() {
    let ZoneId = this.ServiceForm?.value.AddressData.OriginAddress.ZoneId;

    if (ZoneId && ES_Zones.includes(ZoneId)) {
      this.PickUpHourTypeSelected = PickUpHourType.SPECIFIC
      this.PickUpHourTypeList = this.PickUpHourTypeList.filter((x: PickUpHourType) => { return x == PickUpHourType.SPECIFIC });
      if (this.PickUpHourTypeSelected === PickUpHourType.SPECIFIC) {
        this.setSpecificHour();
      }
    } else {
      if (this.StartDateObject && this.EndDateObject) {
        const start = moment(`${this.StartDateObject.Date} ${this.StartDateObject.Hour}`, 'DD-MM-YYYY HH:mm');
        const end = moment(`${this.EndDateObject.Date} ${this.EndDateObject.Hour}`, 'DD-MM-YYYY HH:mm');
        const diff = end.diff(start, 'minutes');

        this.PickUpHourTypeSelected = diff <= 30 ? PickUpHourType.SPECIFIC : PickUpHourType.RANGE;

        if (this.PickUpHourTypeSelected === PickUpHourType.SPECIFIC) {
          this.setSpecificHour();
        }
      }
    }


  }

  setSpecificHour() {
    this.SpecificHourSelected = {
      Start: this.StartDateObject?.Hour,
      End: this.EndDateObject?.Hour == this.StartDateObject?.Hour ? moment(this.StartDateObject?.Hour, "HH:mm").add(30, 'minutes').format("HH:mm") : this.EndDateObject?.Hour
    };
  }

  getDateString(dateTimeStr: string): string {
    const date = moment(dateTimeStr, 'DD-MM-YYYY HH:mm');
    return date.isValid() ? date.format('DD-MM-YYYY') : '';
  }

  getHourString(dateTimeStr: string): string {
    const date = moment(dateTimeStr, 'DD-MM-YYYY HH:mm');
    return date.isValid() ? date.format('HH:mm') : '';
  }


  currentAvailableHours: Hour[] = []


  getAvailableHours() {
    this.LoadingAvailableHours = true
    let params: ProductAvailabilityParams = {
      productId: this.PrincipalProductId,
      selectedDate: moment(this.StartDateObject?.Date, 'DD-MM-YYYY')
        .set({
          hour: moment().hour(),
          minute: moment().minute(),
          second: moment().second()
        })
        .toISOString(),
      isSpecificHours: this.PickUpHourTypeSelected == PickUpHourType.SPECIFIC,
    }
    this.FunnelService.getProductAvailabilityRequest(params).subscribe((data: Hour[]) => {
      this.currentAvailableHours = [...data]

      if (this.PickUpHourTypeSelected == PickUpHourType.SPECIFIC) {
        this.setSpecificAvailableHours(data)
      } else {
        this.setRangeAvailableHours(data)
      }
      this.LoadingAvailableHours = false;

    })
  }

  setSpecificAvailableHours(data: Hour[]) {
    this.hoursOfDaySpecific = this.formatAvailability(data);

    this.NotHoursAvailable = this.hoursOfDaySpecific?.length == 0;

    const selectedRange = `${this.SpecificHourSelected.Start} - ${this.SpecificHourSelected.End}`;
    if (!this.hoursOfDaySpecific.includes(selectedRange)) {
      this.onRangeHourChange(""); // Borra horas
    }
  }

  setRangeAvailableHours(data: Hour[]) {
    this.hoursOfDay = data.filter((x: Hour) => { return !x.Disabled }).map((x: Hour): string => { return x.Text }).slice(0, -3);

    this.hoursOfDayEndDate = [...this.currentAvailableHours].map((x: Hour): string => { return x.Text })
    this.NotHoursAvailable = this.hoursOfDay?.length == 0;

    if (this.StartDateObject && !this.hoursOfDay.includes(this.StartDateObject.Hour)) {
      this.onStartHourChange("");
    } else {
      if (this.StartDateObject) {
        this.onStartHourChange(this.StartDateObject.Hour);
      }
    }

    // Validar hora de fin
    if (this.EndDateObject && !this.hoursOfDayEndDate.includes(this.EndDateObject.Hour)) {
      this.onEndHourChange("");
    }
  }


  formatAvailability(data: Hour[]): string[] {
    const availableTimes = data.filter(item => !item.Disabled);
    let formattedTimes = this.sharedFunnelService.transformHours(availableTimes).map((x: ConcatenatedHour) => { return x.displayText })
    return formattedTimes;
  }

  // Función para verificar si el siguiente tiempo es un intervalo de 15 minutos
  isNextInterval(currentTime: string, nextTime: string): boolean {
    const currentMinutes = parseInt(currentTime.split(':')[1]);
    const nextMinutes = parseInt(nextTime.split(':')[1]);

    return nextMinutes === currentMinutes + 30 || (currentMinutes === 30 && nextMinutes === 0);
  }

  filterEndDateOptions(startTime: string): string[] {
    // Convertir la hora seleccionada a un objeto moment para facilitar la comparación
    const startMoment = moment(startTime, "HH:mm");

    // Filtrar las horas del segundo array que son al menos 3 horas posteriores a la hora seleccionada
    return this.hoursOfDayEndDate.filter(hour => {
      const currentMoment = moment(hour, "HH:mm");
      const diffInHours = currentMoment.diff(startMoment, 'hours'); // Diferencia en horas
      return diffInHours >= 3; // Asegura que la hora esté al menos 3 horas después
    });
  }

  onPickUpTypeChange(event: PickUpHourType) {
    this.PickUpHourTypeSelected = event;
    this.getAvailableHours();
  }


  onDateChange(event: string) {
    if (this.StartDateObject && this.EndDateObject) {
      const formattedDateUTC = moment.utc(event).format("DD-MM-YYYY");
      this.StartDateObject.Date = formattedDateUTC;
      this.EndDateObject.Date = formattedDateUTC;

      this.DayContactForm.get('StartDate')?.patchValue(`${formattedDateUTC} ${this.StartDateObject.Hour}`);
      this.DayContactForm.get('EndDate')?.patchValue(`${formattedDateUTC} ${this.EndDateObject.Hour}`);

      this.getAvailableHours();
    }
  }

  onStartHourChange(event: string) {
    if (this.StartDateObject) {
      this.StartDateObject.Hour = event;
      this.DayContactForm.get('StartDate')?.patchValue(`${this.StartDateObject.Date} ${event}`);
      this.hoursOfDayEndDate = [...this.hoursOfDay];
      this.hoursOfDayEndDate = this.filterEndDateOptions(this.StartDateObject.Hour);
      this.NotRangeAvailable = this.hoursOfDayEndDate.length === 0;

      if (this.EndDateObject && !this.hoursOfDayEndDate?.includes(String(this.EndDateObject?.Hour))) {
        this.EndDateObject.Hour = '';
      }

    }
  }

  onEndHourChange(event: string) {
    if (this.EndDateObject) {
      this.EndDateObject.Hour = event;
      this.DayContactForm.get('EndDate')?.patchValue(`${this.EndDateObject.Date} ${event}`);
    }
  }

  onRangeHourChange(event: string) {
    if (event != "") {
      const [startHour, endHour] = event.split(' - ');

      if (this.SpecificHourSelected && this.StartDateObject && this.EndDateObject) {
        this.SpecificHourSelected.Start = startHour;
        this.SpecificHourSelected.End = endHour;
        this.DayContactForm.get('StartDate')?.patchValue(`${this.StartDateObject.Date} ${startHour}`);
        this.DayContactForm.get('EndDate')?.patchValue(`${this.EndDateObject.Date} ${endHour}`);
      }
    } else {
      if (this.StartDateObject && this.SpecificHourSelected && this.EndDateObject) {
        this.SpecificHourSelected.Start = "";
        this.SpecificHourSelected.End = "";
        this.DayContactForm.get('StartDate')?.patchValue(`${this.StartDateObject.Date} ${""}`);
        this.DayContactForm.get('EndDate')?.patchValue(`${this.EndDateObject.Date} ${""}`);
      }
    }
  }



  // CONTACTS 

  scrollToElement(childComponent: string) {
    scrollToElement(this.containerId, childComponent)
  }



  areContactsEqual(): boolean {
    const origin = this.DayContactForm.get('OriginContact')?.value;
    const destination = this.DayContactForm.get('DestinationContact')?.value;

    if (!origin || !destination) {
      return false;
    }

    return Object.keys(origin).every(
      key => origin[key] === destination[key]
    );
  }

  private originFormSubscription: Subscription | null = null;

  private initContactFormSync(): void {
    if (this.pickupContactSamePerson) {
      this.originFormSubscription?.unsubscribe();

      this.originFormSubscription = this.originContactFormGroup.valueChanges.subscribe(value => {
        this.destinationContactFormGroup.patchValue(value, { emitEvent: false });
      });

      this.destinationContactFormGroup.patchValue(this.originContactFormGroup.value, { emitEvent: false });
    }
  }

  togglePickupContactSamePerson(): void {
    this.pickupContactSamePerson = !this.pickupContactSamePerson;

    if (this.pickupContactSamePerson) {
      this.initContactFormSync();
    } else {
      this.originFormSubscription?.unsubscribe();

      setTimeout(() => {
        this.scrollToElement(this.DestinationContainerId)
      }, 10)
    }
  }

  get originContactFormGroup() {
    return this.DayContactForm.get('OriginContact') as FormGroup;
  }

  get destinationContactFormGroup() {
    return this.DayContactForm.get('DestinationContact') as FormGroup;
  }


  updateSummaryDataEmitter(event: SummaryData) {
    this.FakeSummaryData.CustomFields = event.CustomFields;
    this.ServiceDetails.CustomFields = event.CustomFields;
    this.updateServiceDetailsEmitter.emit(this.ServiceDetails)
  }


}

